import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fdbfec7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5fdbfec7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdbfec7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdbfec7')) {
      api.createRecord('5fdbfec7', component.options)
    } else {
      api.reload('5fdbfec7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5fdbfec7&scoped=true", function () {
      api.rerender('5fdbfec7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/pcConfig/homeSettings/index.vue"
export default component.exports